import {VALIDATE_ENROLLMENTHOOK} from '@/costregistration/actions/costregistration';
import {BUY} from '@/costregistration/actions/costregistration';
import {CUSTOM_BUY} from '@/costregistration/actions/costregistration';
import {CLOSE_DIALOG} from '@/costregistration/actions/costregistration';
import {COMPLETE_PAYMENT} from '@/costregistration/actions/costregistration';

const defaultState = {
    initialized: false,
    isLoading: false,
};

/**
 * Counts the buys with nothing to pay and the completed payment returns, so a screen that reads the subscription data
 * itself knows to read it again.
 */
const countPaymentChange = (state, payload) =>
    payload?.reload ? (state.paymentChanges ?? 0) + 1 : state.paymentChanges;

const app = (state = defaultState, action) => {
    const {type, payload} = action;

    switch (type) {
        // VALIDATE_ENROLLMENTHOOK
        case `${VALIDATE_ENROLLMENTHOOK}_PENDING`: {
            state.isLoading = true;

            return {
                ...state,
            };
        }
        case `${VALIDATE_ENROLLMENTHOOK}_FULFILLED`: {
            state.reload = false;
            state.initialized = true;
            state.isLoading = false;

            return {
                ...state,
                ...payload,
            };
        }
        case `${VALIDATE_ENROLLMENTHOOK}_REJECTED`: {
            state.isLoading = false;

            return {
                ...state,
            };
        }
        // VALIDATE_ENROLLMENTHOOK

        // BUY
        case `${BUY}_PENDING`: {
            state.isLoading = true;

            return {
                ...state,
            };
        }
        case `${BUY}_FULFILLED`: {
            state.isLoading = false;

            return {
                ...state,
                ...payload,
                paymentChanges: countPaymentChange(state, payload),
            };
        }
        case `${BUY}_REJECTED`: {
            state.isLoading = false;
            return {
                ...state,
            };
        }
        // BUY

        // CUSTOM_BUY
        case `${CUSTOM_BUY}_PENDING`: {
            state.isLoading = true;

            return {
                ...state,
            };
        }
        case `${CUSTOM_BUY}_FULFILLED`: {
            state.isLoading = false;

            return {
                ...state,
                ...payload,
            };
        }
        case `${CUSTOM_BUY}_REJECTED`: {
            state.isLoading = false;

            return {
                ...state,
            };
        }
        // BUY

        // COMPLETE_PAYMENT
        case `${COMPLETE_PAYMENT}_FULFILLED`: {
            return {
                ...state,
                ...payload,
                paymentChanges: countPaymentChange(state, payload),
            };
        }
        // COMPLETE_PAYMENT

        // CLOSE_DIALOG
        case `${CLOSE_DIALOG}_FULFILLED`: {
            return {
                ...defaultState,
                reload: true,
            };
        }
        // CLOSE_DIALOG

        default:
            return state;
    }
};

export default app;
